import EnlilAxios from "../../../../util/EnlilAxios";
import {V1DeveloperExceptionIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";


class DeveloperExceptionEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let QBE = this.getQBEForRequest()
        if (!QBE) {
            QBE = {
                "ShifamedMessage": {
                    "-idoc": this.getIDOCResponse() ?? "v1.DeveloperException-001",
                    "-id": uuidv4(),
                    "DeveloperException": {
                        '_attributes': {
                            'limit': pageSize,
                            'sort': this.getFormattedSortSpecification(),
                            'offset': (page - 1) * pageSize
                        },
                        "QueryGroups": {
                            "QueryGroup": [
                                {
                                    "Name": "primary",
                                    "Operator": "AND",
                                    "Type": "QueryGroup",
                                    "Membership": {
                                        "Member": []
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.ShifamedMessage.DeveloperException.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        EnlilAxios({
            method: "GET",
            url: "t2/v1/developer_exceptions",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.DeveloperException-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1DeveloperExceptionIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
}

export default DeveloperExceptionEnterpriseComponent;